import { render } from "./AlbumCreationForm.vue?vue&type=template&id=0f726f56&scoped=true"
import script from "./AlbumCreationForm.vue?vue&type=script&lang=js"
export * from "./AlbumCreationForm.vue?vue&type=script&lang=js"

import "./AlbumCreationForm.vue?vue&type=style&index=0&id=0f726f56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f726f56"]])

export default __exports__